import {DEFAULT_DISPLAY_VALUE, FIELD_ANALYZER_REPORT, LIQUID, VISION_APPLY_REPORT} from './applicationReportConstants'

export function headerData(apiData, product) {
    const headerInfo = {
        name: apiData.company.companyDisplayName,
        addressLine1: apiData.company.addressLine1,
        addressLine2: apiData.company.addressLine2,
        addressLine3: apiData.company.addressLine3,
        phone: apiData.company.contactNumber,
        email: apiData.company.emailAddress,
        subtitle: product,
        workorder: {
            woNumber: apiData.workOrderNumber || DEFAULT_DISPLAY_VALUE,
            woName: apiData.jobName,
        },
    }

    return headerInfo
}

export function fieldInformationData(apiData) {
    let countyState = DEFAULT_DISPLAY_VALUE
    if (apiData.field.county && apiData.field.state) {
        countyState = apiData.field.county + ' ' + apiData.field.state
    }
    else if (!apiData.field.county && apiData.field.state) {
        countyState = apiData.field.state
    }
    else if (apiData.field.county && !apiData.field.state) {
        countyState = apiData.field.county
    }

    const fieldInformation = {
        customer: apiData.grower.name || 'No Customer',
        office: apiData.grower.telephone1,
        address: apiData.grower.address,
        cell: apiData.grower.telephone2,
        email: apiData.grower.email,
        farm: apiData.farm.name || 'No Farm',
        field: apiData.field.name || 'No Field',
        township: apiData.field.township,
        countyState: countyState,
        section: apiData.field.section,
    }

    return fieldInformation
}

export function appDetailDataBigScreen(apiData, sessionIndexes, uomPreference) {
    return splitApplicationDetail(5, apiData, sessionIndexes, uomPreference)
}

export function appDetailDataSmallScreen(apiData, sessionIndexes, uomPreference) {
    return splitApplicationDetail(2, apiData, sessionIndexes, uomPreference)
}

function appDetailData(apiData, sessionIndexes, uomPreference) {
    const colNames = []
    const completionDate = []
    const startTime = []
    const stopTime = []
    const operator = []
    const license = []
    const completedArea = []
    const totalVolume = []
    const totalWeight = []
    const equipment = []
    const groundSpeed = []
    const boomHeight = []
    const tipTypeTipSize = []
    const tipPressure = []
    const fieldConditions = []
    const defaultRate = []
    const minimumRate = []
    const maximumRate = []
    const isLiquid = apiData.sessions[sessionIndexes[0]].product.productType === LIQUID

    for (let i = 0; i < sessionIndexes.length; i++) {
        const opId = appDetailOperator(apiData, sessionIndexes, i)
        const notes = appDetailNotes(apiData, sessionIndexes, i)
        const tipTypeSize = (apiData.sessions[sessionIndexes[i]].equipments[0].tipType || DEFAULT_DISPLAY_VALUE) + ' / ' + (apiData.sessions[sessionIndexes[i]].equipments[0].tipSize || DEFAULT_DISPLAY_VALUE)
        const groundSpeedProps = {isUOM: true, uomPreference: uomPreference, imperialUnits: 'mph', metricUnits: 'km/h', baseUnits: 'm/sec', removeUnitsIfDefault: true}
        let rateProps
        if (isLiquid) {
            rateProps = {isUOM: true, metricUnits: 'L/ha', imperialUnits: 'gal/ac', baseUnits: 'L/m2', precision: 2, defaultDisplayValue: '0.00', allowTruncate: false}
        }
        else {
            rateProps = {isUOM: true, metricUnits: 'kg/ha', imperialUnits: 'lb/ac', baseUnits: 'kg/m2', precision: 2, defaultDisplayValue: '0.00', allowTruncate: false}
        }

        colNames.push(i + 1)
        completionDate.push({value: getFormattedDateString(convertToDate(apiData.sessions[sessionIndexes[i]].startTime))})
        startTime.push({value: getFormattedDateTimeString(convertToDate(apiData.sessions[sessionIndexes[i]].startTime))})
        stopTime.push({value: getFormattedDateTimeString(convertToDate(apiData.sessions[sessionIndexes[i]].stopTime))})
        completedArea.push({value: Number(apiData.sessions[sessionIndexes[i]].totalArea), isUOM: true, uomPreference: uomPreference, metricUnits: 'ha', imperialUnits: 'ac', removeUnitsIfDefault: true, allowTruncate: false, precision: 2})
        totalVolume.push({value: Number(apiData.sessions[sessionIndexes[i]].product.totalVolume) || 0, isUOM: true, uomPreference: uomPreference, metricUnits: 'L', imperialUnits: 'gal', baseUnits: 'L', removeUnitsIfDefault: true, allowTruncate: false, precision: 2})
        totalWeight.push({value: Number(apiData.sessions[sessionIndexes[i]].product.totalWeight) || 0, isUOM: true, uomPreference: uomPreference, metricUnits: 'kg', imperialUnits: 'lb', baseUnits: 'kg', removeUnitsIfDefault: true, allowTruncate: false, precision: 2})
        boomHeight.push({value: Number(apiData.sessions[sessionIndexes[i]].equipments[0].height), isUOM: true, uomPreference: uomPreference, imperialUnits: 'in', metricUnits: 'cm', baseUnits: 'm', removeUnitsIfDefault: true, allowTruncate: false, precision: '0'})
        tipTypeTipSize.push({value: tipTypeSize})
        tipPressure.push({value: apiData.sessions[sessionIndexes[i]].equipments[0].tipPressure || DEFAULT_DISPLAY_VALUE})
        fieldConditions.push({value: notes ? notes : ''})
        if (apiData.reportType === FIELD_ANALYZER_REPORT || apiData.reportType === VISION_APPLY_REPORT) {
            if (apiData.sessions[sessionIndexes[i]].fieldAnalyzerSettings) {
                defaultRate.push({...{value: Number(apiData.sessions[sessionIndexes[i]].fieldAnalyzerSettings.defaultRate)}, ...rateProps})
                minimumRate.push({...{value: Number(apiData.sessions[sessionIndexes[i]].fieldAnalyzerSettings.minimumRate), alwaysShow: true}, ...rateProps})
                maximumRate.push({...{value: Number(apiData.sessions[sessionIndexes[i]].fieldAnalyzerSettings.maximumRate)}, ...rateProps})
            }
            else if (apiData.sessions[sessionIndexes[i]].visionApplySettings) {
                defaultRate.push({...{value: Number(apiData.sessions[sessionIndexes[i]].visionApplySettings.defaultRate)}, ...rateProps})
                minimumRate.push({...{value: Number(apiData.sessions[sessionIndexes[i]].visionApplySettings.minimumRate), alwaysShow: true}, ...rateProps})
                maximumRate.push({...{value: Number(apiData.sessions[sessionIndexes[i]].visionApplySettings.maximumRate)}, ...rateProps})
            }
            else {
                maximumRate.push({value: 'n/a' })
                minimumRate.push({value: 'n/a' })
                defaultRate.push({value: 'n/a' })
            }
        }

        if (apiData.operators.length > 0) {
            operator.push({value: apiData.operators[opId].name})
            license.push({value: apiData.operators[opId].licenseNumber})
            equipment.push({value: apiData.operators[opId].systemName})
            groundSpeed.push({...{value: Number(apiData.operators[opId].averageApplicationSpeed)}, ...groundSpeedProps})
        }
    }

    const applicationDetail = {
        tableTitle: 'Application Details',
        columnNames: colNames,
        completionDate: completionDate,
        startTime: startTime,
        stopTime: stopTime,
        operator: operator,
        license: license,
        completedArea: completedArea,
        totalVolume: totalVolume,
        totalWeight: totalWeight,
        equipment: equipment,
        groundSpeed: groundSpeed,
        boomHeight: boomHeight,
        tipTypeTipSize: tipTypeTipSize,
        tipPressure: tipPressure,
        fieldConditions: fieldConditions,
        isLiquid: isLiquid,
        defaultRate: defaultRate,
        minimumRate: minimumRate,
        maximumRate: maximumRate,
    }

    return applicationDetail
}

function appDetailOperator(apiData, sessionIndexes, i) {
    let opId = 0 // default to operator 0
    for (let j = 0; j < apiData.operators.length; j++) {
        if (apiData.operators[j].fileIndex == apiData.sessions[sessionIndexes[i]].fileIndex && apiData.operators[j].id == apiData.sessions[sessionIndexes[i]].latestOperatorId) {
            opId = j
        }
    }

    return opId
}

function appDetailNotes(apiData, sessionIndexes, i) {
    let notes = null
    if (apiData.notes.length >= apiData.sessions[sessionIndexes[i]].fileIndex + 1) {
        notes = apiData.notes[apiData.sessions[sessionIndexes[i]].fileIndex]
    }

    return notes
}

function splitApplicationDetail(tableColumns, apiData, sessionIndexes, uomPreference) {
    const applicationDetailWhole = appDetailData(apiData, sessionIndexes, uomPreference)

    let tableCount
    const appDetailTableCols = applicationDetailWhole.completionDate.length

    tableCount = (appDetailTableCols - (appDetailTableCols % tableColumns)) / tableColumns
    if (appDetailTableCols % tableColumns) {
        tableCount += 1
    }

    const columnNames = []
    const completionDate = []
    const startTime = []
    const stopTime = []
    const operator = []
    const license = []
    const completedArea = []
    const totalVolume = []
    const totalWeight = []
    const equipment = []
    const groundSpeed = []
    const boomHeight = []
    const tipTypeTipSize = []
    const tipPressure = []
    const fieldConditions = []
    const defaultRate = []
    const minimumRate = []
    const maximumRate = []

    for (let i = 0; i < tableCount; i++) {
        columnNames.push(applicationDetailWhole.columnNames.splice(0, tableColumns))
        completionDate.push(applicationDetailWhole.completionDate.splice(0, tableColumns))
        startTime.push(applicationDetailWhole.startTime.splice(0, tableColumns))
        stopTime.push(applicationDetailWhole.stopTime.splice(0, tableColumns))
        operator.push(applicationDetailWhole.operator.splice(0, tableColumns))
        license.push(applicationDetailWhole.license.splice(0, tableColumns))
        completedArea.push(applicationDetailWhole.completedArea.splice(0, tableColumns))
        totalVolume.push(applicationDetailWhole.totalVolume.splice(0, tableColumns))
        totalWeight.push(applicationDetailWhole.totalWeight.splice(0, tableColumns))
        equipment.push(applicationDetailWhole.equipment.splice(0, tableColumns))
        groundSpeed.push(applicationDetailWhole.groundSpeed.splice(0, tableColumns))
        boomHeight.push(applicationDetailWhole.boomHeight.splice(0, tableColumns))
        tipTypeTipSize.push(applicationDetailWhole.tipTypeTipSize.splice(0, tableColumns))
        tipPressure.push(applicationDetailWhole.tipPressure.splice(0, tableColumns))
        fieldConditions.push(applicationDetailWhole.fieldConditions.splice(0, tableColumns))
        if (applicationDetailWhole.defaultRate) defaultRate.push(applicationDetailWhole.defaultRate.splice(0, tableColumns))
        if (applicationDetailWhole.minimumRate) minimumRate.push(applicationDetailWhole.minimumRate.splice(0, tableColumns))
        if (applicationDetailWhole.maximumRate) maximumRate.push(applicationDetailWhole.maximumRate.splice(0, tableColumns))
    }
    const appDetailDataSplit = {
        tableTitle: applicationDetailWhole.tableTitle,
        columnNames: columnNames,
        completionDate: completionDate,
        startTime: startTime,
        stopTime: stopTime,
        operator: operator,
        license: license,
        completedArea: completedArea,
        totalVolume: totalVolume,
        totalWeight: totalWeight,
        equipment: equipment,
        groundSpeed: groundSpeed,
        boomHeight: boomHeight,
        tipTypeTipSize: tipTypeTipSize,
        tipPressure: tipPressure,
        fieldConditions: fieldConditions,
        isLiquid: applicationDetailWhole.isLiquid,
        defaultRate: defaultRate,
        minimumRate: minimumRate,
        maximumRate: maximumRate,
    }

    return appDetailDataSplit
}

function getFormattedDateString(date) {
    if (!date) {
        return DEFAULT_DISPLAY_VALUE
    }

    return date.toLocaleDateString()
}
function convertToDate(dateString) {
    if (dateString) {
        const newDate = new Date(dateString)
        if (newDate instanceof Date && !isNaN(newDate.getTime())) {
            return newDate
        }
    }

    return null
}

function getFormattedDateTimeString(date) {
    if (!date) {
        return DEFAULT_DISPLAY_VALUE
    }

    return date.toLocaleString([], {
        hour12: false,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    })
}

// For a product mix with a single ingredient and no carrier, the source RAD XML
// omits the ingredient's rate and quantity. In that case the whole applied
// product is that one ingredient.
export function resolveIngredientRateAndQuantity(ingredient, { ingredientCount, hasCarrier, mixRate, mixQuantity }) {
    let rate = Number(ingredient.rate)
    let quantity = Number(ingredient.quantity)

    const quantityMissing = !quantity
    const mixRateUsable = Number.isFinite(mixRate) && mixRate > 0
    const mixQuantityUsable = Number.isFinite(mixQuantity) && mixQuantity > 0

    if (ingredientCount === 1 && !hasCarrier && quantityMissing && mixRateUsable && mixQuantityUsable) {
        rate = mixRate
        quantity = mixQuantity
    }

    return { rate, quantity }
}
